export default __webpack_public_path__ + "static/media/pic (9).cbf12726.jpg";